export const useStyles = (MUITheme) => ({
    UserProfilePopUpContainer: {
        width: 400,
        borderRadius: 4,
        margin: 0,
        position: "absolute",
        top: 10,
        right: 60,
        backgroundColor: MUITheme.palette.background.white,
        boxShadow:
            "0 1px 1px 0 rgba(0,0,0,0.07), 0 2px 1px -1px rgba(0,0,0,0.07), 0 1px 3px 0 rgba(0,0,0,0.1)",
        zIndex: 1,
    },
    mobUserProPopup: {
        top: 120,
        right: "30%",
        transform: "translateX(15%)",
        "@media(max-width:560px)": {
            width: "80%",
            right: "10%",
            transform: "translateX(0)",
            "& h4": {
                fontSize: 16,
                wordBreak: "break-all",
            },
        },
    },
    userProfileMenuList: {
        padding: 0,
        borderTopWidth: 1,
        borderTopStyle: "solid",
        borderTopColor: MUITheme.palette.border.grey,
        margin: 0,
        maxHeight: "60vh",
        overflow: "auto",
        "& li": {
            padding: "12px 20px",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            listStyle: "none",
            "& > div": { display: "flex" },
            "& svg": {
                color: "#757575",
                verticalAlign: "middle",
            },
            "& span": {
                color: MUITheme.palette.text.darkGrey,
                fontFamily: MUITheme.typography.fontFamily,
                fontSize: 16,
                letterSpacing: 0.5,
            },
            "&:hover": { background: MUITheme.palette.background.mainContent },
        },
    },
    title: {
        fontSize: 18,
        fontWeight: 700,
        letterSpacing: 0.5,
    },
    orgTitle: {
        fontSize: 16,
        color: MUITheme.palette.text.lightGrey,
    },
    selectedOrganization: {
        color: MUITheme.palette.text.darkGrey,
    },
    teamListItem: {
        display: "flex",
        gap: 15,
    },
    orgNameContainer: {
        width: "100%",
        display: "flex",
        gap: 20,
        justifyContent: "space-between",
    },
    orgNameAndRole: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
    },
    orgEditButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "5px",
        boxSizing: "border-box",
        minWidth: "45px !important",
        minHeight: "45px !important",
        borderRadius: "100%",
        "& span": {
            width: 20,
            height: 20,
            paddingLeft: "0 !important",
        },
        "& svg": {
            width: 20,
            height: 20,
        },
    },
    orgStatus: {
        fontSize: 12,
        color: MUITheme.palette.text.lilac,
    },
    signoutLink: {
        display: "flex",
        gap: 10,
        borderTopWidth: 1,
        borderTopStyle: "solid",
        borderTopColor: MUITheme.palette.text.disabled,
    },
});
